import { createContext, use } from "react";

import type {
  AtualizarEtapaInput,
  EtapaDoFluxoPendenteType,
} from "@repo/graphql-types/graphql";

export interface FlowStepContextValue {
  step: EtapaDoFluxoPendenteType;
  nextStep: (step?: AtualizarEtapaInput) => Promise<void>;
  goBack: () => void;
  isLoading: boolean;
  progress: number;
  imageSrc: string;
}

export const FlowStepContext = createContext<FlowStepContextValue | null>(null);

// eslint-disable-next-line react-refresh/only-export-components -- context file intentionally exports both context and hook
export const useFlowStepContext = (): FlowStepContextValue => {
  const context = use(FlowStepContext);
  if (!context) {
    throw new Error("useFlowStepContext must be used within a FlowStepContext.Provider");
  }
  return context;
};
